import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ErrorActionTypes, SetErrorAction } from '@ispm/shared/store/actions/error.actions';
import { NotificationMessageService } from '@ispm/core/components/customise-notification/notifications-message.service';

@Injectable()
export class ErrorEffects {

  constructor(private actions$: Actions,
              private notificationMessageService: NotificationMessageService) {
  }

  @Effect({ dispatch: false})
  error$: Observable<Action> = this.actions$.pipe(
    ofType<SetErrorAction>(ErrorActionTypes.SET_ERROR),
    tap((action: SetErrorAction) => {
      this.notificationMessageService.error(action.payload.userMessage);
      console.log(`${action.payload.devMessage}: ${action.payload.error}`);
    })
  );

}
